module.exports = __webpack_public_path__ + "static/media/de_nuke.fe912814.svg";